// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6688c824","263":"b2d58337","335":"9a57156e","742":"848b8eb2"}[chunkId] + ".chunk.js";
};